export default class SharedResource
{
    constructor()
    {
        this.reference_count = 0;
    }

    getReferenceCount()
    {
        return this.reference_count;
    }

    hasReferences()
    {
        return this.getReferenceCount() > 0;
    }

    hasNoReferences()
    {
        return this.getReferenceCount() === 0;
    }

    increment()
    {
        this.reference_count++;
    }

    decrement()
    {
        if (this.reference_count > 0)
        {
            this.reference_count--;
        }
    }
}